import React from "react";
import IntegrityAudit from "./IntegrityAudit";

export default function AdmissibilityAudit() {
  return <IntegrityAudit />;
}
